import React, { Component } from 'react';
import style from './index.module.css';

class Chapter6 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { status, freeChargeMoney, isMultiCar, rule } = this.props.data;
    const { setInstructionModel } = this.props;
    // if (status === 0) return;

    return (
      <div
        className={style.pageBgType3}
        style={{
          height: document.documentElement.clientHeight - 0
        }}
      >
        <div
          style={{
            height: document.documentElement.clientHeight - 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            paddingRight: 0,
            paddingLeft: 0,
            paddingTop: 0
          }}
        >
          {status === 1 && (
            <div
              className={style.itemBox}
            >
              {isMultiCar && rule && (
                <div
                  className={style.instructionsIconBox}
                  onClick={() => setInstructionModel(rule)}
                />
              )}
              {/* <div className={style.xpIconBox} /> */}
              <p className={style.ordinaryText}>
                2021年小鹏免费充电权益
                <br />
                <span className={style.blueBigText}>
                  为你节省
                  <br />
                  {freeChargeMoney}元
                </span>
              </p>
              <br />
              <span className={style.grayNormalText}>最少的钱，走最远的路</span>
            </div>
          )}
          <div className={style.chapter6Icon} />
        </div>
      </div>
    );
  }
}

export default Chapter6;
